<template>
  <div class="tab-cover-wrap ">
    <h1 class="text-[14px] font-bold text-[#14171F]">Provide name and details of beneficial owner.</h1>
    <p class="text-[14px] font-semibold text-[#14171F] mt-4">Role at the business</p>

   <div class="business-status pt-4">
      <div class="">
        <div class="flex  justify-between items-center mb-8 pl-2">
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Owner' }]" @click="selectOption('Owner')"></div>
            <p class="ml-2 text-[64px] font-bold text-[#383F51]">Owner</p>
          </div>
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Director' }]" @click="selectOption('Director')"></div>
            <p class="ml-2 text-[14px] font-bold text-rose-500">Director</p>
          </div>
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Shareholder' }]" @click="selectOption('Shareholder')"></div>
            <p class="ml-2 text-[14px] font-bold text-rose-500">Shareholder</p>
          </div>
        </div>

        <div v-if="selected === 'Owner'">
          <Owner :selected="selected" @openIdentity="openIdentity" />
        </div>
        
        <div v-if="selected === 'Director'" >
          <Director />
        </div>

         <div v-if="selected === 'Shareholder'" >
          <Shareholder />
        </div>
      </div>

    </div>
  </div>
</template>

 <script>
 import Shareholder from './modules/Shareholder.vue';
 import Director from './modules/Director.vue';
 import Owner from './modules/Owner.vue';

export default {
   components: {
        Owner,
        Shareholder,
        Director
       
    },
  data() {
    return {
      selected: null, 
      // ownerName: '',
    };
  },
     props: ['selectedReuploadTab'],
       watch: {
  selectedReuploadTab: {
    handler(newVal) {
      if (this.selectedReuploadTab === 'Owner') {
        this.selected = newVal 
      }
    },
    deep: true,
    immediate: true
  }
},
    methods: {
      openIdentity(kycData) {
        // this.ownerName = kycData.fullName;
        this.$emit('openIdentity', kycData); 
      },
      selectOption(option) {
      this.selected = option;
    },
      selectTab(index) {
            this.selectedIndex = index;
        },
    },

  };
  </script>
 
 <style scoped>
 .business-status{
  /* border: 1px solid red; */
 }
 .business-status>:nth-child(1)>:nth-child(1){
  width: 35%;
 }
 .color-box.active {
  background-color: #FFA600;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}

.box-cover>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}
</style>
